import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { TableActionItems } from '../datatable/TableActionItems';
import '../../style/DataTable.css';

const UsersDataTable = (props) => {
  const getUsersData = () => {
    let rowData = [];
    props.users.map((row) =>
      rowData.push({
        username: row.username ? row.username : 'N/A',
        isAdmin: !!row.isAdmin ? 'Jah' : 'Ei',
        representedTeamName: row.representedTeamName
          ? row.representedTeamName
          : 'N/A',
        actions: !!row.isAdmin ? (
          ''
        ) : (
          <TableActionItems deleteAction={() => props.deleteAction(row.id)} />
        ),
      })
    );
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        {
          label: 'Kasutajanimi',
          field: 'username',
          sort: 'asc',
        },
        {
          label: 'Esindatav võistkond',
          field: 'representedTeamName',
        },
        {
          label: 'Administraator',
          field: 'isAdmin',
        },
        {
          label: '',
          field: 'actions',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getUsersData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default UsersDataTable;
